import React, { useCallback } from 'react'

import { CAMPAIGN_REGISTER_MODAL } from 'mednet-util/src/constants/modal'

import { Modal } from 'pharmacy/src/display/modal'
import { Body1, Header1, Header3 } from 'pharmacy/src/typography'
import { Button } from 'pharmacy/src/input/button'

import { useActiveUsersCount } from 'mednet-cns/src/hooks/user'

import * as css from './registerModal.scss'

const isValidRedirectUrl = (url) => {
  if (!url) return false
  if (!url.startsWith('/')) return false
  if (url.startsWith('//')) return false

  const urlPath = url.split('?')[0]
  const pathLower = urlPath.toLowerCase()

  if (pathLower === '/') {
    return false
  }

  const excludePatterns = [
    '/user/login',
    '/user/registration',
    '/user/user/',
    '/register',
    '/recoverpassword',
    '/user/recovery',
    '/home/index',
  ]

  for (const pattern of excludePatterns) {
    const patternLower = pattern.toLowerCase()
    if (
      pathLower === patternLower ||
      `${pathLower}/`.startsWith(patternLower)
    ) {
      return false
    }
  }

  return true
}

const RegistrationView = ({ campaignId, history }) => {
  const currentPath = history?.location?.pathname || ''
  const [activeUsersCount] = useActiveUsersCount()

  const handleRegisterClick = useCallback(
    (e) => {
      e.preventDefault()

      // Preserve existing query params
      const params = new URLSearchParams(window.location.search)

      // Add/override with new params
      params.set('utm_campaign', campaignId)
      params.set('src', 'public_campaign')
      params.set('src_path', currentPath)
      params.set('src_item', 'registration_modal')

      // Add from parameter if valid redirect URL
      if (currentPath && isValidRedirectUrl(currentPath)) {
        params.set('from', currentPath)
      }

      // Always go to /user/registration - PHP will redirect to V2 if needed
      window.location.href = `/user/registration?${params}`
    },
    [campaignId, currentPath]
  )

  const handleLoginClick = useCallback(
    (e) => {
      e.preventDefault()

      // Preserve existing query params
      const params = new URLSearchParams(window.location.search)

      // Add/override with new params
      params.set('src', 'public_campaign')
      params.set('src_path', currentPath)
      params.set('src_item', 'registration_modal')

      // Add from parameter if valid redirect URL
      if (currentPath && isValidRedirectUrl(currentPath)) {
        params.set('from', currentPath)
      }

      // Always go to /user/login - PHP will redirect to V2 if needed
      window.location.href = `/user/login?${params}`
    },
    [currentPath]
  )

  return (
    <div className={css.modal}>
      <div className={css.section}>
        <Header1>To continue please login or register</Header1>
        <Body1 className={css.buttons}>
          <Button type="primary" onClick={handleRegisterClick}>
            Register
          </Button>{' '}
          Or{' '}
          <Button type="secondary" onClick={handleLoginClick}>
            Sign in
          </Button>
        </Body1>
      </div>
      <hr />
      <div className={css.section}>
        <Header3>Why do I have to sign in?</Header3>
        <Body1 className={css.expl}>
          theMednet is a private community of{' '}
          {activeUsersCount?.toLocaleString() ?? '33,000'} academic and
          community physicians. To maintain open and collegial dialogue, we
          verify that all members are practicing US based physicians.
        </Body1>
      </div>
    </div>
  )
}

const screens = {
  [CAMPAIGN_REGISTER_MODAL.screens.view]: RegistrationView,
}

export default function RegistrationModal(props) {
  return (
    <Modal
      modalId={CAMPAIGN_REGISTER_MODAL.modalId}
      defaultScreen={CAMPAIGN_REGISTER_MODAL.screens.view}
      screens={screens}
      {...props}
    />
  )
}
